import React from "react";
function SimpleCase() {
    return (
        <React.Fragment>
            <h5>Caso Semplice</h5>
            <p>In questo semplice esempio aprendo la console si può visualizzare l'ordine con cui vengono eseguiti i diversi tipi di "Effect".</p>
            <iframe height="300" style={{ width: "100%" }} scrolling="no" title="useSyncExternalStore simple case" src="https://codepen.io/FAngelo94/embed/JjpRpVO?default-tab=js%2Cresult&editable=true" frameborder="no" loading="lazy" allowtransparency="true" allowfullscreen="true">
                See the Pen <a href="https://codepen.io/FAngelo94/pen/JjpRpVO">
                    useSyncExternalStore simple case</a> by Angelo Falci (<a href="https://codepen.io/FAngelo94">@FAngelo94</a>)
                on <a href="https://codepen.io">CodePen</a>.
            </iframe>
        </React.Fragment>
    );
}

export default SimpleCase;